import * as types from './constants';

// Swagger
export const getSwaggerRequest = () => (
  { type: types.GET_SWAGGER_REQUEST }
);

export const getSwaggerDone = data => (
  { type: types.GET_SWAGGER_DONE, payload: data }
);

export const getSwaggerFailed = errors => (
  { type: types.GET_SWAGGER_FAILED, payload: errors }
);